import { atom } from 'jotai'
import type { User } from '@/src/services/user'

export const GUEST_USER = {
  id: 'guest',
  email: 'guest@polaris.com',
  name: 'Guest',
  auth_provider: 'guest',
}

/**
 * Always defined. Hydrated by the server.
 */
export const userAtom = atom<User>(GUEST_USER)

/**
 * Is hydrated by the server.
 */
export const sessionIdAtom = atom<string | undefined>()
